module.exports = __webpack_public_path__ + "static/media/Architecture_13.def5ba8b.jpg";